import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { QuestionnaireObject, QuestionnaireScores } from "./models";
import { MapView } from "@abaco/map-web-module/src/modules/map-web-module/models/AbacoMap";

export default class EarthwormVuexModule extends AbacoVuexModule
{
    @State() tablesData!: QuestionnaireObject[]
    @State() tablesColumns!: string[]
    @State() tablesLoading!: boolean

    @State() globalMapView!: MapView | null

    @State() mapSelectedRadar!: QuestionnaireScores | null;
}
